var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75013 9C6.75013 6.1005 9.10063 3.75 12.0001 3.75C14.8996 3.75 17.2501 6.1005 17.2501 9C17.2501 11.8734 14.9417 14.2077 12.0781 14.2494C12.0521 14.2493 12.0261 14.2492 12.0001 14.2492C11.9741 14.2492 11.9481 14.2493 11.9221 14.2494C9.05859 14.2077 6.75013 11.8734 6.75013 9ZM8.53739 14.7953C6.56829 13.6163 5.25013 11.4621 5.25013 9C5.25013 5.27208 8.2722 2.25 12.0001 2.25C15.728 2.25 18.7501 5.27208 18.7501 9C18.7501 11.4621 17.432 13.6163 15.4629 14.7953C16.2125 15.0378 16.9376 15.3594 17.6256 15.7566C19.3359 16.7442 20.7561 18.1646 21.7434 19.8751C21.9505 20.2338 21.8276 20.6925 21.4688 20.8996C21.1101 21.1066 20.6514 20.9837 20.4443 20.6249C19.5886 19.1425 18.3578 17.9115 16.8755 17.0556C15.417 16.2135 13.7656 15.7637 12.0825 15.7495C12.055 15.7498 12.0276 15.75 12.0001 15.75C11.9726 15.75 11.9452 15.7498 11.9178 15.7495C10.2346 15.7637 8.58324 16.2135 7.12474 17.0556C5.64246 17.9115 4.41161 19.1425 3.55593 20.6249C3.34886 20.9837 2.89017 21.1066 2.53144 20.8996C2.1727 20.6925 2.04975 20.2338 2.25682 19.8751C3.24415 18.1646 4.66435 16.7442 6.37468 15.7566C7.06263 15.3594 7.78776 15.0378 8.53739 14.7953Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.d96fe10fa4a0b0b0eeb2f1cca7c9879d.svg";
export { ForwardRef as ReactComponent };